<template>
  <div>
    <v-progress-circular
      :value="engagementScore"
      size="32"
      :color="engagementScoreColor(engagementScore)"
      class="font-weight-bold"
      ><span class="caption">{{ engagementScore }}</span></v-progress-circular
    >
  </div>
</template>

<script>
export default {
  name: "EngagementScoreCircle",
  props: {
    engagementScore: {
      type: [String, Number],
      required: true,
    },
  },
  methods: {
    engagementScoreColor(engagementScore) {
      if (engagementScore < 50) {
        return "red";
      }
      return "green";
    },
  },
};
</script>
